/*
 * Desplazamiento automático del carrusel de la "Galería de clientas" (solo móvil).
 *
 * Coste en reposo: cero. No hay listeners de scroll ni requestAnimationFrame; el trabajo se limita a un setInterval que
 * solo existe mientras el carrusel puede avanzar de verdad. Se detiene (y se destruye el temporizador) cuando la
 * galería sale de pantalla, cuando la pestaña pasa a segundo plano, en escritorio —ahí la galería es una cuadrícula— y
 * con prefers-reduced-motion. Si la clienta toca, arrastra o usa el teclado dentro del carrusel, manda ella: paramos y
 * reanudamos RESUME_DELAY después.
 *
 * Cada avance hace dos lecturas de layout (scrollLeft y scrollWidth/clientWidth) en lugar de medir imagen por imagen:
 * como todas comparten ancho y separación, basta con medir una vez el "paso" y la posición de la primera, y cachearlo
 * hasta que cambie el ancho del carrusel (rotación de pantalla). La posición actual se deduce del scroll real, así que
 * un swipe manual nunca descoloca el siguiente avance.
 */
(function () {
  if (customElements.get('customer-gallery-carousel')) return;

  // Compartidas por todas las secciones: una MediaQueryList basta para cualquier número de galerías en la página.
  var MOBILE = matchMedia('(max-width: 699px)');
  var REDUCED_MOTION = matchMedia('(prefers-reduced-motion: reduce)');
  var RESUME_DELAY = 4000;
  // pointerdown ya cubre el swipe táctil (no hace falta touchstart) y wheel el scroll con trackpad.
  var PAUSE_EVENTS = ['pointerdown', 'wheel', 'keydown'];

  class CustomerGalleryCarousel extends HTMLElement {
    connectedCallback() {
      var seconds = parseFloat(this.getAttribute('autoplay'));

      // Sin atributo (o con un valor inservible) la sección se queda tal cual: carrusel manual.
      if (!(seconds > 0)) return;

      this.delay = Math.max(1, seconds) * 1000;
      this.timer = this.resumeTimer = 0;
      this.onScreen = true;
      this.measuredAt = -1;

      this.sync = this.sync.bind(this);
      this.pause = this.pause.bind(this);
      this.advance = this.advance.bind(this);

      MOBILE.addEventListener('change', this.sync);
      REDUCED_MOTION.addEventListener('change', this.sync);
      document.addEventListener('visibilitychange', this.sync);
      PAUSE_EVENTS.forEach((type) => this.addEventListener(type, this.pause, { passive: true }));

      // observe() dispara una primera entrada con el estado actual, así que este observer también hace el sync inicial.
      this.observer = new IntersectionObserver((entries) => {
        this.onScreen = entries[entries.length - 1].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (!this.delay) return;

      this.stop();
      clearTimeout(this.resumeTimer);
      MOBILE.removeEventListener('change', this.sync);
      REDUCED_MOTION.removeEventListener('change', this.sync);
      document.removeEventListener('visibilitychange', this.sync);
      PAUSE_EVENTS.forEach((type) => this.removeEventListener(type, this.pause));
      this.observer.disconnect();
    }

    /* Única puerta de entrada: decide si el temporizador debe existir. */
    sync() {
      if (MOBILE.matches && this.onScreen && !REDUCED_MOTION.matches && !document.hidden) {
        if (!this.timer) this.timer = setInterval(this.advance, this.delay);
      } else {
        this.stop();
      }
    }

    stop() {
      this.timer = clearInterval(this.timer);
    }

    pause() {
      this.stop();
      clearTimeout(this.resumeTimer);
      this.resumeTimer = setTimeout(this.sync, RESUME_DELAY);
    }

    advance() {
      var total = this.children.length;
      var max = this.scrollWidth - this.clientWidth;

      // En cuadrícula (o con todo a la vista) no hay recorrido: nada que hacer.
      if (total < 2 || max < 1) return;

      // Se remide solo cuando cambia el ancho disponible; en el caso normal esto no toca el layout.
      if (this.measuredAt !== this.clientWidth) this.measure();
      if (!(this.step > 0)) return;

      var next = Math.round((this.scrollLeft - this.origin) / this.step) + 1;
      // Al llegar a la última imagen (o al tope, donde el scroll queda recortado) volvemos al principio.
      var left = next >= total || this.scrollLeft >= max - 1 ? 0 : this.origin + next * this.step;

      // El navegador ya recorta el valor al rango válido, y funciona igual en RTL (scrollLeft negativo).
      this.scrollTo({ left: left, behavior: 'smooth' });
    }

    /* origin = scroll en el que la primera imagen queda centrada; step = distancia entre imágenes consecutivas. */
    measure() {
      var self = this.getBoundingClientRect();
      var first = this.children[0].getBoundingClientRect();

      this.step = this.children[1].getBoundingClientRect().left - first.left;
      this.origin = this.scrollLeft + first.left + first.width / 2 - (self.left + self.width / 2);
      this.measuredAt = this.clientWidth;
    }
  }

  customElements.define('customer-gallery-carousel', CustomerGalleryCarousel);
})();
